<div class="loginPanel">



    <!-- Panel de login -->
    <div class="contenido">

        <div class="space"></div>

        <div class=" tarjeta" (keydown.enter)="IniciarSesion()">
            <div class="contenido">

                <div class="logo">
                    <img [src]="logo" />
                </div>

                <div class="divisor48"></div>

                <!-- Cuenta -->
                <div class="col-12">

                    <div class="floatLabel inputRedondeado">

                        <input placeholder="{{'Login.Cuenta' | translate }}" autofocus id="lcuenta" type="text" class="form-control inputLoginModal"
                               [(ngModel)]="login.Cuenta" name="cuenta" #cuenta="ngModel" required
                               [ngClass]="{'is-filled':cuenta.value }">

                               <button *ngIf="cuenta.value" class="btnTimes" (click)="login.Cuenta = '';" onclick="Focus('lcuenta')" tabindex="-1">
                            <span class="fa fa-times"></span>
                        </button>

                        <span class="textoError" [hidden]="cuenta.valid || (!cuenta.touched && !login.errorActivo)">
                            {{'Login.ErrorCuenta' | translate}}
                        </span>

                    </div>

                </div>

                <div class="divisor24"></div>

                <!-- Id -->
                <div class="col-12">

                    <div class="floatLabel inputRedondeado">

                        <input placeholder="{{'Login.Id' | translate }}" autofocus id="lid" type="text" class="form-control inputLoginModal"
                               [(ngModel)]="login.Id" name="id" #id="ngModel" required
                               [ngClass]="{'is-filled':id.value }">

                               <button *ngIf="id.value" class="btnTimes" (click)="login.Id = '';" onclick="Focus('lid')" tabindex="-1">
                            <span class="fa fa-times"></span>
                        </button>

                        <span class="textoError" [hidden]="id.valid || (!id.touched && !login.errorActivo)">
                            {{'Login.ErrorId' | translate}}
                        </span>

                    </div>

                </div>

                <div class="divisor24"></div>

                <!-- password -->
                <div class="col-12">

                    <div class="floatLabel inputRedondeado">
                        <input placeholder="{{'Login.Password' | translate}}" type="{{verPassword ? 'text' : 'password'}}" id="lpassword" class="form-control inputPassword" [(ngModel)]="login.Password" name="password"
                               #password="ngModel" required [ngClass]="{'is-filled':password.value }">

                               <button *ngIf="password.value" class="btnTimes passwordInput" (click)="login.Password = '';" onclick="Focus('lpassword')" tabindex="-1">
                            <span class="fa fa-times"></span>
                        </button>

                        <button class="btnVerPassword" (click)="CambiarVerPassword()">
                            <span class="fa fa-eye" *ngIf="verPassword"></span>
                            <span class="fa fa-eye-slash" *ngIf="!verPassword"></span>
                        </button>

                        <span class="textoError" [hidden]="password.valid || (!password.touched && !errorActivo)">
                            {{'Login.ErrorPassword' | translate}}
                        </span>

                    </div>

                </div>

                <div class="divisor32"></div>

                <!-- btn iniciar sesión -->
                <div class="col-12 text-center">
                    <button id="botonLogin" class="btn boton filled redondeado" (click)="IniciarSesion()">
                        {{'Login.Login' | translate}}
                    </button>
                </div>

                <!-- Recuperar Contraseña -->
                <ng-container *ngIf="verRecuperarPassword">
                    <div class="divisor24"></div>

                    <div class="divisorgris"></div>

                    <div class="divisor12"></div>

                    <div class="col-12 text-center">
                        <a class="enlace" (click)="RecuperarPassword()">
                            {{'Login.RecuperarPassword' | translate}}
                        </a>
                    </div>
                </ng-container>

            </div>
            <div class="divisor32"></div>
            <div class="col-12 text-center">
              <a href="https://www.idec.edu.mx/web7/aviso-de-privacidad/" target="_blank" class="enlace">
                  Consulte el aviso de privacidad
              </a>
          </div>
        </div>



        <div class=" space">

        </div>
    </div>


</div>

<recuperarPassword #recuperarPassword></recuperarPassword>
